/* eslint-disable */
import TaskManagement from './index'
import TaskDetail from './task-detail'
export default [
  {
    path: '/task-management',
    component: TaskManagement,
    props: (route) => ({
      queryConditions: {
        ref: ['Tasks'],
        filter: [['metaData.byEmail', 'array-contains', null], ['@deleted', '==', false], ['isActive', '==', true]],
        order: ['dueDate', 'asc'],
        limit: 50,
        returnSnapshot: true 
      }
    })
  },
  {
    name: '/task-management/task-detail',
    path: '/task-management/task-detail',
    component: TaskDetail,
    props: (route) => ({
      id: route.query.id ? route.query.id : route.params.orderId,
      mode: route.query.mode ? route.query.mode : route.params.mode,
      data: route.params.data,
      scaffolding: route.params.scaffolding
    })
  }
]
